/** Caché sessionStorage para hub coliving (lista inicial sin filtros de ciudad). */
const STORAGE_PREFIX = 'cl_hub_list_v1';
const TTL_MS = 5 * 60 * 1000;

function storageKey(region, sortBy) {
  return `${STORAGE_PREFIX}:${region || 'es'}:${sortBy || 'market_relevance'}`;
}

export function readColivingHubListCache(region, sortBy) {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(storageKey(region, sortBy));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.savedAt || !Array.isArray(parsed.results)) return null;
    if (Date.now() - parsed.savedAt > TTL_MS) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeColivingHubListCache(region, sortBy, results, totalResults) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(
      storageKey(region, sortBy),
      JSON.stringify({
        savedAt: Date.now(),
        results,
        totalResults: totalResults ?? results.length,
      }),
    );
  } catch {
    /* quota / private mode */
  }
}

/** Hub sin ciudad ni filtros que cambien el merge en backend. */
export function isHubBaselineListQuery(queryParams, selectedLocations, currentCity) {
  if (queryParams.contractType !== 'coliving') return false;
  if (currentCity) return false;
  if (selectedLocations?.length) return false;
  if (queryParams.propertyLocation || queryParams.propertyLocations || queryParams.searchLocation) {
    return false;
  }
  if (queryParams.providers) return false;
  if (queryParams.responseMode === 'map') return false;
  const filterKeys = [
    'minPrice', 'maxPrice', 'maxRoomPrice', 'allowsPets', 'allowsCouples',
    'forStudents', 'proOnly', 'maxMinimumStay', 'servicesInternet',
    'servicesCleaning', 'servicesAllIncluded', 'accommodationType', 'minBathrooms',
    'hasAirConditioning', 'hasElevator', 'hasParking',
  ];
  return !filterKeys.some((k) => queryParams[k] != null && queryParams[k] !== '');
}
